<template>
    <b-container class="my-3" v-if="isLoaded">
        <b-card class="cardBackground mbs-1" no-body>
            <Hero
                    :title="$store.getters['base/account/getFullName'](target.user)"
                    :subtitle="target.evaluationQuestionnaire.name"
                    :logo="$store.getters['base/account/getAvatar'](target.user)"
                    id="campaign-detail-hero"
            >
                <b-progress
                        :value="progression.step+1"
                        :max="steps.length"
                        variant="primary"
                        class="hero--progress"
                />
            </Hero>
            <b-card-body>
                <b-container class="py-4">
                    <!-- Affichage de la question -->
                    <div
                        v-for="(question, index) of progression.questions"
                        :key="'step-'+index">
                        <!-- Nordique en mode EDIT -->
                        <evaluation-nordique-week
                            v-if="question.type === 'nordique_week' && mode === 'edit'"
                            :key="'nordique-week-'+index"
                            :pains="answers.pains"
                            @change="onPains($event)"
                        />
                        <evaluation-nordique-year
                            v-else-if="question.type === 'nordique_year' && mode === 'edit'"
                            :key="'nordique-year-'+index"
                            :pains="answers.pains"
                            @change="onPains($event)"
                        />
                        <!-- Nordique en mode VIEW -->
                        <b-row v-else-if="question.type === 'nordique_week' && mode === 'view'">
                            <b-col class="d-flex justify-content-center align-items-center">
                                <svg-model-h-front
                                    disabled-color="#333333"
                                    default-color="lightgray"
                                    style="height: 300px!important;"
                                    :colors="nordic.pain"
                                    :key="'pain-front-'+index"
                                />
                            </b-col>
                            <b-col class="d-flex justify-content-center align-items-center">
                                <svg-model-h-back
                                    disabled-color="#333333"
                                    default-color="lightgray"
                                    style="height: 300px!important;"
                                    :colors="nordic.pain"
                                    :key="'pain-back-'+index"
                                />
                            </b-col>
                        </b-row>
                        <b-row v-else-if="question.type === 'nordique_year' && mode === 'view'">
                            <b-col class="d-flex justify-content-center align-items-center">
                                <svg-model-h-front
                                    disabled-color="#333333"
                                    default-color="lightgray"
                                    style="height: 300px!important;"
                                    :colors="nordicYear.pain"
                                    :key="'pain-front-'+index"
                                />
                            </b-col>
                            <b-col class="d-flex justify-content-center align-items-center">
                                <svg-model-h-back
                                    disabled-color="#333333"
                                    default-color="lightgray"
                                    style="height: 300px!important;"
                                    :colors="nordicYear.pain"
                                    :key="'pain-back-'+index"
                                />
                            </b-col>
                        </b-row>
                        <!-- GOLLAC en édition -->
                        <evaluation-gollac
                            v-else-if="question.type === 'gollac' && mode === 'edit'"
                            @change="endGollac($event)"
                        />
                        <!-- RICCI GAGNON en édition -->
                        <evaluation-ricci-gagnon
                            v-else-if="question.type === 'ricci_gagnon' && mode === 'edit'"
                            @change="endRicciGagnon($event)"
                        />
                        <!-- Question classique -->
                        <evaluation-question
                            v-else
                            :question="question.evaluationQuestion"
                            :question-questionnaire="question"
                            :answers="answers.questions[progression.step]"
                            :mode="mode"
                            :key="'question-'+question.id"
                            @change="onAnswer($event)"
                            class="my-2"
                        />
                    </div>
                    <div
                        v-if="isLoaded && !isLoading && progression.questions.length === 0"
                        class="alert alert-secondary">
                        Toutes les questions du questionnaire ont été répondues
                    </div>
                </b-container>
            </b-card-body>
            <!-- Navigation entre question en mode EDIT -->
            <b-card-footer class="bg-white d-flex justify-content-between" v-if="mode === 'edit'">
                <b-button
                    variant="primary"
                    :disabled="progression.step === 0"
                    @click="progression.step = progression.step - 1;setQuestions()">
                    Précédent
                </b-button>
                <b-button
                        :variant="isLastStep ? 'success' : 'primary'"
                        :disabled="!progression.canSubmit"
                        :class="[{ 'loading': isLoading }]"
                        @click="onSubmit"
                >
                    <template v-if="!isLastStep">Suivant</template>
                    <template v-else>Terminer</template>
                </b-button>
            </b-card-footer>
            <!-- Navigation entre question en mode VIEW -->
            <b-card-footer
                    class="bg-white d-flex justify-content-between"
                    v-else
            >
                <b-button
                        v-if="progression.step > 0"
                        variant="primary"
                        @click="progression.step = progression.step - 1;setQuestions()"
                >
                    Précédent
                </b-button>
                <b-button
                        variant="primary"
                        :to="{name: 'campaigns'}"
                        v-else
                >
                    Revenir à la liste des questionnaires
                </b-button>
                <b-button
                        v-if="progression.step+1 < steps.length"
                        variant="primary"
                        @click="progression.step = progression.step + 1;setQuestions()"
                >
                    Suivant
                </b-button>
                <b-button
                        variant="primary"
                        :to="{name: 'campaigns'}"
                        v-else
                >
                    Revenir à la liste des questionnaires
                </b-button>
            </b-card-footer>
        </b-card>
    </b-container>
</template>
<script>
    import moment from 'moment'
    import Hero from "../../components/Hero";
    import EvaluationNordiqueWeek from "../../components/evaluation/nordique/Week";
    import EvaluationQuestion from "../../components/evaluation/Question";
    import SvgModelHFront from "../../components/svg/ModelHFront";
    import SvgModelHBack from "../../components/svg/ModelHBack";
    import EvaluationNordiqueYear from "../../components/evaluation/nordique/Year";
    import swal from 'sweetalert'
    import EvaluationGollac from "../../components/evaluation/Gollac";
    import EvaluationRicciGagnon from "../../components/evaluation/RicciGagnon";

    export default {
        name: 'campaign-detail',
        components: {
            EvaluationRicciGagnon,
            EvaluationGollac,
            EvaluationNordiqueYear,
            SvgModelHBack,
            SvgModelHFront,
            EvaluationQuestion,
            EvaluationNordiqueWeek,
            Hero
        },
        data: () => ({
            moment,
            isLoaded: false,
            isLoading: false,
            progression: {
                step: 0,
                questionsAnswered: 0,
                questions: [],
                canSubmit: false
            },
            answers: {
                gollac: [],
                ricciGagnon: [],
                pains: {
                    hasYear: {},
                    hasWeek: {},
                    douleursWeek: {}
                },
                nordics: [],
                questions: []
            },
            steps: [],
            mode: 'view',
            hasNordiqueYear: false
        }),
        async mounted() {
            await this.$store.dispatch('base/campaign/getEvaluationQuestionnaireFromTarget', {id: this.targetId})
            this.mode = this.target.workflowState === 'done' ? 'view' : 'edit'
            /* Grouper les questions par étapes */
            const steps = [];
            const questions = [];
            for (const question of this.target.evaluationQuestionnaire.evaluationQuestionEvaluationQuestionnaires) {
                const step = question.step - 1
                if (steps[step] === undefined) steps[step] = [];
                steps[step].push(question);
                questions[step] = [];
            }
            this.steps = steps;
            this.$set(this.answers, 'questions', questions)
            /* Gestion de la progression quand on reprend un questionnaire */
            let i = this.target.evaluationReponses.length
            let k = 0;
            for (const step of this.steps) {
                if (i === 0) {
                    this.progression.step = k
                    break
                }
                i -= step.length;
                k++;
            }
            /* Récupération des nordiques */
            let promises = [];
            let stepToFill = [];
            for (const r of this.target.evaluationReponses) {
                if (r.evaluationQuestionEvaluationQuestionnaire.type === 'question') {
                    this.answers.questions[r.evaluationQuestionEvaluationQuestionnaire.step - 1].push({
                        question: r.evaluationQuestionEvaluationQuestionnaire.id,
                        answer: r.value,
                        obligatoire: r.evaluationQuestionEvaluationQuestionnaire.isMandatory
                    })
                } else if (['nordique_week', 'nordique_year'].includes(r.evaluationQuestionEvaluationQuestionnaire.type)) {
                    if (r.evaluationQuestionEvaluationQuestionnaire.type === 'nordique_year')
                        this.hasNordiqueYear = true
                    promises.push(this.$store.dispatch('base/evaluation/nordic/retrieve', {evaluationId: r.value}))
                    stepToFill.push({step: r.evaluationQuestionEvaluationQuestionnaire.step - 1, id: r.value})
                }
            }
            /* Si il y a des nordiques, alors on remplit le tableau des douleurs avec les données récuppérées */
            if (promises.length > 0) {
                await Promise.all(promises)
                stepToFill.forEach((step) => {
                    this.answers.nordics[step.step] = this.$store.state.base.evaluation.nordic.list[step.id]
                    this.$store.state.base.evaluation.nordic.list[step.id].questionnairesNordique.forEach((qN) => {
                        this.answers.pains.hasYear[qN.bodyPart] = qN.hasPainYear
                        this.answers.pains.hasWeek[qN.bodyPart] = (this.mode === 'edit' && this.hasNordiqueYear) ?
                            null : qN.hasPainWeek
                        this.answers.pains.douleursWeek[qN.bodyPart] = (this.mode === 'edit' && this.hasNordiqueYear) ?
                            null : qN.intensityDouleurWeek
                    })
                })
            }
            /* Settage des questions */
            this.setQuestions();
            this.isLoaded = true;
        },
        computed: {
            ouId() {
                return this.$route.query.ou
            },
            programId() {
                return this.$route.query.program
            },
            nordicColors() {
                return this.$store.getters['base/evaluation/nordic/colors']
            },
            nordicYear() {
                const evaluation = this.answers.nordics[this.progression.step]
                if (evaluation === undefined) return {pain: {}}
                return {date: moment(evaluation.createdAt.date), pain: this.generatePainColorsYear(evaluation)}
            },
            nordic() {
                const evaluation = this.answers.nordics[this.progression.step]
                if (evaluation === undefined) return {pain: {}}
                return {date: moment(evaluation.createdAt.date), pain: this.generatePainColors(evaluation)}
            },
            isLastStep() {
                return this.progression.step + 1 === this.steps.length
            },
            step() {
                const steps = this.steps[this.progression.step];
                if (steps === undefined) {
                    return [];
                }
                return steps;
            },
            types() {
                return this.step.map((q) => {
                    return q.type
                })
            },
            targetId() {
                return parseInt(this.$route.params.id)
            },
            target() {
                return this.$store.state.base.campaign.evaluationQuestionnaireCible
            }
        },
        methods: {
            canSubmit() {
                this.progression.canSubmit = false
                let canSubmit = true;
                let numberOfQuestionToAnswer = 0;
                for (const question of this.progression.questions) {
                    if (['nordique_week', 'nordique_year'].includes(question.type)) {
                        let numOfAnswerWeek = 0;
                        Object.keys(this.answers.pains.hasWeek).forEach((member) => {
                            if (this.answers.pains.hasWeek[member] !== null &&
                                this.answers.pains.hasWeek[member] !== undefined)
                                numOfAnswerWeek++;
                        });
                        let numofAnswerYear = 0;
                        Object.keys(this.answers.pains.hasYear).forEach((member) => {
                            if (this.answers.pains.hasYear[member] !== null &&
                                this.answers.pains.hasYear[member] !== undefined)
                                numofAnswerYear++;
                        });
                        if (
                            (question.type === 'nordique_week' && numOfAnswerWeek < 17)
                            ||
                            (question.type === 'nordique_year' && numofAnswerYear < 17)
                        )
                            canSubmit = false;
                    } else if ('gollac' === question.type) {
                        canSubmit = this.answers.gollac.length > 0
                    } else if ('ricci_gagnon' === question.type) {
                        canSubmit = Object.keys(this.answers.ricciGagnon).length > 0
                    } else if (question.isMandatory) {
                        numberOfQuestionToAnswer++;
                    }
                }
                if (this.progression.questionsAnswered < numberOfQuestionToAnswer) canSubmit = false;
                this.progression.canSubmit = canSubmit
            },
            setQuestions() {
                this.progression.questions = this.step.filter((q) => {
                    if (q.parent === null) return q
                    for (const step of this.answers.questions) {
                        for (const question of step) {
                            if (question.question === q.parent.id && question.answer === q.parentAnswer) return q
                        }
                    }
                }).sort((a, b) => {
                    return a.rank - b.rank
                })
                this.progression.questionsAnswered = this.answers.questions[this.progression.step].length
                this.canSubmit()
            },
            generatePainColors({questionnairesNordique}) {
                const pain = {}
                for (const item of questionnairesNordique)
                    pain[item.bodyPart] = this.nordicColors[item.intensityDouleurWeek]
                return pain
            },
            generatePainColorsYear({questionnairesNordique}) {
                const pain = {}
                for (const item of questionnairesNordique) {
                    pain[item.bodyPart] = this.nordicColors[item.hasPainYear ? 5 : 0]
                }
                return pain
            },
            onPains({data}) {
                this.$set(this.answers, 'pains', data)
                this.canSubmit()
            },
            onAnswer(data) {
                if (data.answer !== null) {
                    if (this.answers.questions[this.progression.step].filter((a) => {
                        return a.question === data.question
                    }).length > 0) {
                        for (let answer of this.answers.questions[this.progression.step]) {
                            if (answer.question === data.question)
                                answer.answer = data.answer
                        }
                    } else {
                        this.answers.questions[this.progression.step].push(data)
                        if (data.isMandatory) this.progression.questionsAnswered++;
                    }
                } else {
                    if (this.answers.questions[this.progression.step]
                        .filter((q) => {
                            return q.question === data.question
                        }).length > 0) {
                        this.answers.questions[this.progression.step] = this.answers.questions[this.progression.step]
                            .filter((q) => {
                                return q.question !== data.question
                            })
                        if (data.isMandatory) this.progression.questionsAnswered--
                    }
                }
                this.setQuestions();
                this.canSubmit()
            },
            async onSubmit() {
                this.isLoading = true
                if (this.types.includes('nordique_week')) {
                    const question = this.step.find(step => step.type === 'nordique_week')
                    await this.savePains(question)
                } else if (this.types.includes('nordique_year')) {
                    const question = this.step.find(step => step.type === 'nordique_year')
                    await this.savePains(question)
                } else if (this.types.includes('gollac')) {
                    const question = this.step.find(step => step.type === 'gollac')
                    await this.saveGollac(question)
                } else if (this.types.includes('ricci_gagnon')) {
                    const question = this.step.find(step => step.type === 'ricci_gagnon')
                    await this.saveRicciGagnon(question)
                } else {
                    await this.saveQuestions();
                }
                this.isLoading = false
                if (!this.isLastStep) {
                    this.progression.step++
                    this.progression.questionsAnswered = 0
                    if (this.progression.questions.length === 0) {
                        await this.$store.dispatch('base/campaign/sendAnswers', {
                            id: this.target.id,
                            answers: [],
                            workflowState: 'done'
                        })
                        this.$router.push({
                            name: 'campaigns',
                            query: {
                                'cpg': this.target.evaluationQuestionnaire.id,
                                'program': this.programId,
                                'ou': this.ouId
                            }
                        })
                    }
                    this.setQuestions()
                } else {
                    if (this.target.workflowState !== 'done') {
                        await this.$store.dispatch('base/campaign/sendAnswers', {
                            id: this.target.id,
                            answers: [],
                            workflowState: 'done'
                        })
                    }
                    await swal(
                        'Questionnaire rempli',
                        'Le questionnaire de ' + this.target.user.firstname + ' ' +
                        this.target.user.lastname + ' a été complété',
                        'success'
                    )
                    this.$router.push({
                        name: 'campaigns',
                        query: {
                            'cpg': this.target.evaluationQuestionnaire.id,
                            'program': this.programId,
                            'ou': this.ouId
                        }
                    })
                }
                const topOfPage = document.querySelector('#campaign-detail-hero')
                if (topOfPage) topOfPage.scrollIntoView()
            },
            async saveQuestions() {
                let answers = []
                for (const q of this.answers.questions[this.progression.step]) {
                    answers[q.question] = q.answer
                }
                await this.$store.dispatch('base/campaign/sendAnswers', {
                    id: this.target.id,
                    answers,
                    workflowState: this.isLastStep ? 'done' : 'doing'
                })
            },
            async savePains(question) {
                if (Object.keys(this.answers.pains.hasWeek).length === 0) {
                    Object.keys(this.answers.pains.hasYear).forEach((membre) => {
                        this.answers.pains.hasWeek[membre] = null;
                        this.answers.pains.douleursWeek[membre] = null;
                    })
                }
                if (Object.keys(this.answers.pains.douleursWeek).length === 0) {
                    Object.keys(this.answers.pains.hasWeek).forEach((membre) => {
                        this.answers.pains.douleursWeek[membre] = 0;
                    })
                }
                let evalId = null
                if (this.answers.nordics[this.progression.step] !== undefined) {
                    evalId = this.answers.nordics[this.progression.step].id === undefined ?
                        this.answers.nordics[this.progression.step] : this.answers.nordics[this.progression.step].id
                }
                const {nordicId} = await this.$store.dispatch('base/campaign/answerNordic', {
                    id: this.target.id,
                    questionId: question.id,
                    formData: this.answers.pains,
                    isInstant: false,
                    workflowState: this.isLastStep ? 'done' : 'doing',
                    evalId
                })
                this.answers.nordics[this.progression.step] = nordicId
                this.answers.nordics[this.progression.step + 1] = nordicId
            },
            async saveGollac(question) {
                const {status, statusText, data} = await this.$store.dispatch('base/evaluation/gollac/create', {
                    userId: this.target.user.id,
                    responses: this.answers.gollac
                })
                let answers = []
                answers[question.id] = data
                await this.$store.dispatch('base/campaign/sendAnswers', {
                    id: this.target.id,
                    answers,
                    workflowState: this.isLastStep ? 'done' : 'doing'
                })
            },
            async saveRicciGagnon(question) {
                const {status, statusText, data} = await this.$store.dispatch('base/evaluation/ricci/create', {
                    userId: this.target.user.id,
                    responses: this.answers.ricciGagnon
                })
                let answers = []
                answers[question.id] = data
                await this.$store.dispatch('base/campaign/sendAnswers', {
                    id: this.target.id,
                    answers,
                    workflowState: this.isLastStep ? 'done' : 'doing'
                })
            },
            hasAnsweredQuestion(question) {
                for (const answer of this.target.evaluationReponses) {
                    if (answer.evaluationQuestionEvaluationQuestionnaire.id === question.id)
                        return true
                }
                return false
            },
            endGollac($event) {
                this.answers.gollac = $event
                this.canSubmit()
            },
            endRicciGagnon($event) {
                this.answers.ricciGagnon = $event
                this.canSubmit()
            }
        }
    }
</script>
